export default __webpack_public_path__ + "static/media/imageDesignContentTwo.74abd575.png";